module.exports = __webpack_public_path__ + "static/media/Linkedin.0fc72d80.svg";